import React from 'react'
import { observer } from 'mobx-react-lite'
import { useStore } from '../../../../lib/context'

const Container = observer(({ children, backgroundColor }) => {
	const {uiStore: {scrollPosition}} = useStore();

	return (
		<div>
			<span />
			{children}

			<style jsx>{`
				div {
					display: grid;
					grid-template-columns: 20% 80%;
					background-color: transparent;
					width: 100%;
					align-items: center;
					justify-content: flex-end;
					padding: 0 2.5rem;
					// position: -webkit-sticky;
					// position: sticky;
					align-self: flex-start;
					width: 100%;
					top: 0;
					padding-top: 4vh;
					z-index: 10;
				}
				@media only screen and (max-width: 768px), (pointer: coarse) {
					div {
						grid-template-columns: 100%;
					}
				}
				@media only screen and (max-width: 768px) {
					div {
						display: none;
					}
				}
			`}</style>
		</div>
	)
})

export default Container
